/** Ordered expense IDs from the main table (filtered + sorted) for editor navigation. */
export const TABLE_NAV_LIST_STORAGE_KEY = 'expenseTableNavList';

export function loadTableNavList(): string[] {
  try {
    const raw = sessionStorage.getItem(TABLE_NAV_LIST_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((id) => String(id)).filter(Boolean);
  } catch {
    return [];
  }
}

export function saveTableNavList(ids: string[]): void {
  sessionStorage.setItem(TABLE_NAV_LIST_STORAGE_KEY, JSON.stringify(ids));
}

export function removeIdsFromTableNavList(deletedIds: ReadonlySet<string>): string[] {
  const next = loadTableNavList().filter((id) => !deletedIds.has(id));
  saveTableNavList(next);
  return next;
}

export function getTableNavNeighbors(
  navList: string[],
  activeId: string
): { prev: string | null; next: string | null } {
  const idx = navList.indexOf(activeId);
  if (idx < 0) {
    return { prev: null, next: null };
  }
  return {
    prev: idx > 0 ? navList[idx - 1] : null,
    next: idx < navList.length - 1 ? navList[idx + 1] : null,
  };
}

export function getTableNavPosition(
  navList: string[],
  activeId: string
): { current: number; total: number } {
  const idx = navList.indexOf(activeId);
  if (idx < 0) {
    return { current: 0, total: navList.length };
  }
  return { current: idx + 1, total: navList.length };
}

/** Next visible row after delete — skips removed IDs, follows table row order. */
export function findNextInTableNavList(
  navList: string[],
  activeId: string,
  excludeIds: ReadonlySet<string> = new Set()
): string | null {
  const idx = navList.indexOf(activeId);
  const start = idx >= 0 ? idx + 1 : 0;
  for (let i = start; i < navList.length; i++) {
    if (!excludeIds.has(navList[i])) {
      return navList[i];
    }
  }
  return null;
}
